import {
  BriefcaseBusiness,
  Building2,
  DoorOpen,
  FileCheck2,
  Landmark,
  MapPin,
  NotebookTabs,
  Users,
  UsersRound,
  type LucideIcon
} from 'lucide-react'

export const DASHBOARD_ICONS: Partial<Record<string, LucideIcon>> = {
  members: UsersRound,
  customers: Users,
  sites: MapPin,
  rooms: DoorOpen,
  organizations: Landmark,
  businesses: BriefcaseBusiness,
  subjects: Building2,
  contracts: FileCheck2,
  orders: NotebookTabs
}
